import React, { Component, Fragment } from 'react';
import propTypes from 'prop-types';

import { fullscreenClose, fullscreenOpen } from 'ui/Icons';

import IconButton from './IconButton';
import styles from './ToggleFullscreen.css';

/**
 * toggle fullscreen mode
 */
export default class ToggleFullscreen extends Component {
  static propTypes = {
    onEnterClick: propTypes.func.isRequired,
    onExitClick: propTypes.func.isRequired
  };

  static toggleMode = {
    ENTER: 0,
    EXIT: 1
  };

  constructor(props) {
    super(props);

    this.state = {
      toggleStatus: ToggleFullscreen.toggleMode.ENTER
    };

    this.handleClick = this.handleClick.bind(this);
  }

  /**
   * handle the click
   * @param {Function} propHandler - execute function
   * @param {object} e - event object
   * @returns {undefined}
   */
  handleClick(propHandler, e) {
    const newValue = 1 - Number(e.currentTarget.value);
    this.toggleModal(newValue);
    propHandler();
  }

  /**
   * set toggle status
   * @param {number} toggleStatus - value
   */
  toggleModal(toggleStatus) {
    this.setState({ toggleStatus });
  }

  /**
   * render button with action based on toggle status
   * @returns {React.Component} jsx
   */
  render() {
    const { onEnterClick, onExitClick } = this.props;

    const { toggleStatus } = this.state;

    let action;
    let alt;
    let icon;

    if (toggleStatus === ToggleFullscreen.toggleMode.ENTER) {
      action = this.handleClick.bind(null, onEnterClick);
      icon = fullscreenOpen;
      alt = 'Open';
    } else {
      action = this.handleClick.bind(null, onExitClick);
      icon = fullscreenClose;
      alt = 'Close';
    }

    return (
      <Fragment>
        <button
          type="button"
          onClick={action}
          value={toggleStatus}
          className={styles.toggleButton}
          data-test-id="toggleFullscreen-button"
        >
          <IconButton className={styles.toggleIcon} alt={alt} icon={icon} noMargin rem={2.4} />
        </button>
      </Fragment>
    );
  }
}
